import React from "react";
import "./pdfType.css";
import { useState } from "react";
import { iconData } from "../../../../../../../iconData";
import MideaViewer from "../../../../../../../midea_viewer/MideaViewer";
import "../PdfType/pdfType.css";
import { Player } from "video-react";
import { IP } from "./../../../../../../../internalServer";

export default function PdfQType({ attachData, attachment }) {
  const [mideaviewer, setMideaviewer] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const attachformat = (para) => {
    const filePath = para;
    const fileName = filePath.split("/").pop();
    const fileNameWithoutId = fileName.split("_")[1];
    return fileNameWithoutId;
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };

  return (
    <>
      <div className="total_pdf m-1 border p-1 rounded-2">
        <div
          className="all_pdf_pre"
          style={isError ? { pointerEvents: "none", opacity: 0.5 } : {}}
          onClick={() => {
            const extMatch = attachment?.match(/\.([^.]+)$/);
            const ext = extMatch ? extMatch[1].toLowerCase() : "";
            const isLink =
              attachment.startsWith("http://") ||
              attachment.startsWith("https://");

            if (isLink) {
              window.open(attachment, "_blank");
            } else if (["jpg", "jpeg", "png", "mp4"].includes(ext)) {
              handleClick(attachment);
            } else if (["pdf", "ppt", "pptx"].includes(ext)) {
              handleClickforpdf(attachment);
            }
          }}
        >
          <div className="ContainerUploadedPdf d-flex gap-2 p-1">
            <div className="d-flex align-items-center pdf_logo">
              <img
                src={
                  attachment.startsWith("http://") ||
                  attachment.startsWith("https://")
                    ? "/images/link-icon.png"
                    : iconData?.find(
                        (i) =>
                          i.extension.toLowerCase() ===
                          attachment?.split(".").pop()?.toLowerCase()
                      )?.icon || "/images/file-default.png"
                }
                alt=""
                className="attachLogoActivity"
              />
            </div>

            <div className="pdf_detail" style={{ marginLeft: "5px" }}>
              <div className="d-flex align-items-center justify-content-between">
                <span className="pdf-txt1" title={attachData?.subject_id?.name}>
                  {attachData?.subject_id?.name}
                </span>
              </div>

              <div
                className="pdf-txt2"
                title={attachment.split("/").pop()?.replace(/^\d+_/, "")}
                style={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  maxWidth: "100px",
                }}
              >
                {attachment.split("/").pop()?.replace(/^\d+_/, "")}
              </div>
            </div>
          </div>
        </div>
      </div>

      {mideaviewer && (
        <MideaViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" ||
        responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  {/* {console.log("1st")} */}
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  {/* {console.log("2nd")} */}
                  <img
                    onClick={() => {
                      handleClick();
                      setIsError(false);
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo-1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
    </>
  );
}
